import firebase from "firebase/app";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { RouteName } from "@/consts/RouteName";
import { getPublicConfig } from "@/helpers/getPublicConfig";

const config = getPublicConfig();

export const TouchableLogo: React.FC = (props) => {
  const router = useRouter();
  const onClick = () => {
    firebase
      .analytics()
      .logEvent(AnalyticsEventEnum.Logo, { route: router.route });
  };
  return (
    <Link href={RouteName.Home}>
      <a>
        <div
          className="touchable relative flex items-center w-36"
          onClick={onClick}
        >
          <Image
            src="/logo/logo.svg"
            alt={config.siteName}
            width={126}
            height={36}
            layout="fixed"
            priority
          />
        </div>
      </a>
    </Link>
  );
};
